// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionTitle-module--root--39M0M","line":"SectionTitle-module--line--2lDaL","title":"SectionTitle-module--title--6PLC2 typography-module--responsiveTitle2--1Uzed"};